import { render } from "./galerieImage.vue?vue&type=template&id=4c062921"
import script from "./galerieImage.vue?vue&type=script&lang=ts"
export * from "./galerieImage.vue?vue&type=script&lang=ts"
script.render = render

export default script